import { render, staticRenderFns } from "./Retrieval.vue?vue&type=template&id=24541e06&scoped=true&"
import script from "./Retrieval.vue?vue&type=script&lang=js&"
export * from "./Retrieval.vue?vue&type=script&lang=js&"
import style0 from "./Retrieval.vue?vue&type=style&index=0&id=24541e06&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24541e06",
  null
  
)

export default component.exports